export const donationWallets = [
  { key: "USDT", title: "Tether USD", network: "BNB Smart Chain · BEP20", address: "0x7FCBF41CF35259b466a7516Ec0ED32adAC9fF40f", icon: "/ed-icons/usdt.png" },
  { key: "BTC", title: "Bitcoin", network: "Bitcoin network", address: "bc1q56znh3ptafknppu9q0zqg02kfry4lmwwf5t83y", icon: "/ed-icons/btc.png" },
  { key: "SOL", title: "Solana", network: "Solana network", address: "8wSrr5mesxqjLpcHkfA8d7nMJihumsrTT2BDtoS25AD7", icon: "/ed-icons/sol.png" },
  { key: "XRP", title: "XRP", network: "XRP Ledger", address: "rw9wLrxHnaQi91MJCAx4B5BbnqFaCCXXvn", icon: "/ed-icons/xrp.png" },
] as const;
